import React, { FC } from 'react'
import InputDataItem from './InputDataItem'

interface IInputData {
  data: any
}

const InputData: FC<IInputData> = ({ data }) => {
  return (
    <section className="calc-section">
      <div className="section-name">Input data</div>
      <div className="section-content">
        <ul className="info-list">
          {data !== undefined && (
            Object.entries(data).map((item: any) => (
              <InputDataItem label={item[0]} value={item[1]} key={`${item[0]}-${item[1]}`} />
            ))
          )}
        </ul>
      </div>
    </section>
  )
}

export default InputData